import { Grid, Link } from "@mui/material";
import PrevIcon from "@mui/icons-material/ChevronLeft";
import NextIcon from "@mui/icons-material/ChevronRight";
import React from "react";
import Bouton from "../Button/Bouton";
import Error from "../Error";

interface Props {
  fetching: boolean;
  onPrecedent?(): void;
  onClick?(): void;
  canCancel?: string;
  disabledButton?: boolean;
  messageButton?: string;
  isParcoursCandidatLocataire?: boolean;
}

const FormButtons: React.FC<Props> = ({
  onPrecedent,
  fetching,
  onClick,
  canCancel,
  disabledButton,
  messageButton,
  isParcoursCandidatLocataire,
}: Props) => {
  return (
    <Grid container spacing={10} justifyContent="space-between">
      <Grid item>
        {onPrecedent && (
          <Bouton
            label="Précédent"
            variant="contained"
            color="inherit"
            onClick={onPrecedent}
            size="medium"
            icon={<PrevIcon />}
          />
        )}
      </Grid>
      <Grid item>
        <Grid container direction="column" alignItems="flex-end">
          {onClick && !disabledButton && (
            <Bouton
              label="Enregistrer et suivant"
              variant="contained"
              color="primary"
              size="medium"
              onClick={onClick}
              fetching={fetching}
              icon={<NextIcon />}
            />
          )}
          {!onClick && !disabledButton && (
            <Bouton
              label={
                isParcoursCandidatLocataire
                  ? "Envoyer le mail au candidat locataire"
                  : "Enregistrer et suivant"
              }
              variant="contained"
              color="primary"
              size="medium"
              type="submit"
              fetching={fetching}
              icon={(!isParcoursCandidatLocataire && <NextIcon />) || undefined}
            />
          )}
          {disabledButton && messageButton && <Error text={messageButton} />}
          {canCancel && (
            <Link
              href="/dossier-location/synthese"
              className="defaultLink cancelLink"
            >
              Retour à la synthèse
            </Link>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FormButtons;
